import { render, staticRenderFns } from "./SlideList.vue?vue&type=template&id=211b01d0&lang=pug&"
import script from "./SlideList.vue?vue&type=script&lang=ts&"
export * from "./SlideList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports